import { render, staticRenderFns } from "./index-assessor.vue?vue&type=template&id=32463c4e&"
import script from "./index-assessor.vue?vue&type=script&lang=js&"
export * from "./index-assessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports